import React, { useState, createContext, useContext } from 'react';
import { translations, Lang } from '../constants/translations';
type Ctx = {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: typeof translations.en;
};
const LanguageContext = createContext<Ctx | null>(null);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('en');
  const t = translations[lang];
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-330">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
}